export default {
    title: "Change password",
    old_password: "Enter old password",
    new_password: "Enter new password",
    repeat_password: "Repeatr new password",
    button: "OK"
}